// 10xxx - 18xxx	1: โซนกลาง
// 20xxx - 27xxx	2: โซนตะวันออก
// 30xxx - 39xxx	3: ภาคตะวันออกเฉียงเหนือ ตอนที่ 1
// 40xxx - 49xxx	4: ภาคตะวันออกเฉียงเหนือ ตอนที่ 2
// 50xxx - 58xxx	5: โซนภาคเหนือตอนบน
// 60xxx - 67xxx	6: โซนภาคเหนือตอนล่าง
// 70xxx - 77xxx	7: โซนกลางตอนล่าง
// 80xxx - 86xxx	8: โซนใต้
// 90xxx - 96xxx	9 โซนชายแดนใต้

export const getPostcodeZone = (postcode) => {
  if (postcode) {
    const splitedPostcode = postcode.split('')
    if (splitedPostcode.length > 2) {
      const twoCharacters = parseInt(
        `${splitedPostcode[0]}${splitedPostcode[1]}`
      )
      if (twoCharacters == 10 || twoCharacters == 11 || twoCharacters == 12) {
        return 'BKK'
      } else if (twoCharacters >= 20 && twoCharacters <= 27) {
        return 'EAST'
      } else if (twoCharacters >= 30 && twoCharacters <= 39) {
        return 'NORTH_EAST1'
      } else if (twoCharacters >= 40 && twoCharacters <= 49) {
        return 'NORTH_EAST2'
      } else if (twoCharacters >= 50 && twoCharacters <= 58) {
        return 'NORTH_TOP'
      } else if (twoCharacters >= 60 && twoCharacters <= 67) {
        return 'NORTH_BOTTOM'
      } else if (twoCharacters >= 70 && twoCharacters <= 77) {
        return 'CENTER_BOTTOM'
      } else if (twoCharacters >= 80 && twoCharacters <= 86) {
        return 'SOUTH'
      } else if (twoCharacters >= 90 && twoCharacters <= 96) {
        return 'BORDER_SOUTH'
      } else {
        return 'CENTER'
      }
    }
  }
  return false
}

export const getFuzePostZone = (postcode) => {
  const zone = getPostcodeZone(postcode)
  if (!zone) {
    return false
  }
  switch (zone) {
    case 'NORTH_TOP':
    case 'NORTH_BOTTOM':
    case 'NORTH_EAST1':
    case 'NORTH_EAST2':
    case 'SOUTH':
    case 'BORDER_SOUTH':
      return 'NORTH_SOUTH_ESARN'
    case 'BKK':
      return 'BKK'
    default:
      return 'EAST_WEST'
  }
}

// const postcodes = [
//   {
//     // BKK, MET
//     value: 'BKK',
//     group: [
//       '10110',
//       '10600',
//       '10510',
//       '10230',
//       '10900',
//       '10150',
//       '10210',
//       '10400',
//       '10300',
//       '10170',
//       '10800',
//       '10700',
//       '10500',
//       '10330',
//       '10260',
//       '10200',
//       '10120',
//       '10140',
//       '10520',
//       '10310',
//       '10250',
//       '10240',
//       '10100',
//       '10220',
//       '10160',
//       '10530',
//       //นนทบุรี
//       '11150',
//       '11130',
//       '11110',
//       '11140',
//       '11120',
//       '11000',
//       // ปทุมธานี
//       '12120',
//       '12110',
//       '12130',
//       '12000',
//       '12140',
//       '12150',
//       '12160',
//       '12170',
//       // สมุทรปราการ
//       '10550',
//       '10560',
//       '10540',
//       '10130',
//       '10290',
//       '10280',
//       '10270'
//     ]
//   },
//   {
//     value: 'NORTH_SOUTH_ESARN',
//     group: [
//       '62000',
//       '62130',
//       '62140',
//       '62120',
//       '62180',
//       '62190',
//       '62150',
//       '62210',
//       '62110',
//       '62160',
//       '62170',
//       '57340',
//       '57140',
//       '57150',
//       '57110',
//       '57160',
//       '57230',
//       '57190',
//       '57290',
//       '57120',
//       '57280',
//       '57250',
//       '57000',
//       '57100',
//       '57270',
//       '57240',
//       '57180',
//       '57130',
//       '57220',
//       '57310',
//       '57210',
//       '57170',
//       '57260',

//       '50160',
//       '50240',
//       '50170',
//       '50320',
//       '50260',
//       '50220',
//       '50110',
//       '50190',
//       '50100',
//       '50000',
//       '50200',
//       '50270',
//       '58130',
//       '50150',
//       '50330',
//       '50180',
//       '50360',
//       '50130',
//       '50280',
//       '50350',
//       '50250',
//       '50210',
//       '50290',
//       '50120',
//       '50140',
//       '50230',
//       '50340',
//       '50310',

//       '63150',
//       '63120',
//       '63160',
//       '63000',
//       '63140',
//       '63110',
//       '63180',
//       '63130',
//       '63170',

//       '60230',
//       '60170',
//       '60150',
//       '60120',
//       '60250',
//       '60190',
//       '60260',
//       '60210',
//       '60140',
//       '60160',
//       '60180',
//       '60130',
//       '60220',
//       '60000',
//       '60240',
//       '60110',

//       '55220',
//       '55130',
//       '55160',
//       '55140',
//       '55150',
//       '55180',
//       '55190',
//       '55120',
//       '55000',
//       '55170',
//       '55110',
//       '55210',

//       '56150',
//       '56110',
//       '56160',
//       '56120',
//       '56140',
//       '56000',
//       '56130',

//       '66210',
//       '66110',
//       '66150',
//       '66230',
//       '66120',
//       '66130',
//       '66190',
//       '66000',
//       '66170',
//       '66140',
//       '66220',
//       '66180',
//       '66160',

//       '65170',
//       '65120',
//       '65190',
//       '65110',
//       '65210',
//       '65240',
//       '65140',
//       '65180',
//       '65150',
//       '65230',
//       '65000',
//       '65220',
//       '65130',
//       '65160',

//       '67280',
//       '67270',
//       '67150',
//       '67190',
//       '67260',
//       '67160',
//       '67230',
//       '67000',
//       '67250',
//       '67210',
//       '67240',
//       '67130',
//       '67180',
//       '67170',
//       '67220',
//       '67120',
//       '67110',

//       '54110',
//       '54000',
//       '54140',
//       '54150',
//       '54160',
//       '54120',
//       '54130',
//       '54170',

//       '58140',
//       '58150',
//       '58130',
//       '58000',
//       '58120',
//       '58110',

//       '52130',
//       '52110',
//       '52120',
//       '52160',
//       '52230',
//       '52240',
//       '52000',
//       '52100',
//       '52220',
//       '52150',
//       '52180',
//       '52140',
//       '52170',
//       '52190',

//       '51160',
//       '51180',
//       '51130',
//       '51120',
//       '51000',
//       '51150',
//       '51170',
//       '51140',
//       '51110',

//       '64170',
//       '64160',
//       '64150',
//       '64230',
//       '64140',
//       '64220',
//       '64210',
//       '64180',
//       '64130',
//       '64190',
//       '64120',
//       '64110',

//       '53140',
//       '53230',
//       '53150',
//       '53110',
//       '53190',
//       '53180',
//       '53120',
//       '53220',
//       '53160',
//       '53000',
//       '53170',
//       '53130',

//       '61120',
//       '61140',
//       '61180',
//       '61000',
//       '61160',
//       '61150',
//       '61130',
//       '61110',
//       '61170'
//     ]
//   },

//   {
//     value: 'EAST_WEST',
//     group: []
//   }
// ]
